import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import { insertHoliday, getHoliday, getCategorys, deleteholiday, } from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import FilterComponent from "../pages/FilterComponent";

export default function Holiday() {
  const UID = localStorage.getItem("userId");

  const [addHolidayModal, setAddHolidayModal] = useState(false);
  const [editHolidayModal, setEditHolidayModal] = useState(false);
  const [holidays, setHolidays] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [categorys, setCategorys] = useState([]);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [searchText, setSearchText] = React.useState("");
  const [loading, setLoading] = useState(false);
  // const [searchText, setSearchText] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [deleteHollydayId, setDeleteHollydayId] = useState(null); // Correct naming convention
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const clearData = () => {
    setHolidayData({
      Id: "",
      Name: "",
      Narration: "",
      Remarks: "",
      Year: currentYear.toString(),
      EventDate: "",
      UserId: UID,
    })
  }

  const clearDataForEdit = () => {
    setHolidayData((ref) => ({
      ...ref, // Spread the previous state
      Name: "",
      Narration: "",
      Remarks: "",
      Year: currentYear.toString(),
      EventDate: "",
      UserId: UID,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setHolidayData((prev) => {
      // Check if 'Year' is being changed and 'EventDate' is already set
      if (name === "Year" && prev.EventDate) {
        alert("Changing the year will clear the selected date.");
        return {
          ...prev,
          [name]: value, // Update the Year
          EventDate: "", // Clear the EventDate
        };
      }

      // Default behavior for other fields
      return {
        ...prev,
        [name]: value,
      };
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading spinner

    try {
      const response = await insertHoliday(holidayData); // Add holiday to the database
      if (response.data.data.StatusCode === 200) {
        toast.success("Holiday added successfully!"); // Show success message
        fetchHolidays(); // Refresh holiday list
        openAddHolidayModal(); // Close the modal
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name")) {
        toast.error(errorMessage);
      } else {
        toast.error("Error occurred while adding Holiday.");
      }
      console.error("Error adding Holiday:", error); // Show error message
    } finally {
      setLoading(false); // Stop loading spinner
    }
  };

  // edit
  const handleEdit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading spinner
    try {

      const response = await insertHoliday(holidayData); // Update holiday in the database
      if (response.data.data.StatusCode === 200) {

        toast.success("Holiday edited successfully!"); // Show success message
        fetchHolidays(); // Refresh holiday list
        openEditHolidayModal(); // Close the modal
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name")) {
        toast.error(errorMessage);
      } else {
        toast.error("Error occurred while editing Holiday.");
      }
      console.error("Error editing Holiday:", error); // Show error message
    } finally {
      setLoading(false); // Stop loading spinner
    }
  };


  const handleDelete = async (holidayId) => {
    const removeData = { Id: holidayId, TableName: "Holiday" };
    try {
      const res = await deleteholiday(removeData, UID); // Ensure deleteholiday is an async function
      if (res && res.data) {
        if (res.data.message === "Deleted Successfully") {
          toast.success("Holiday deleted successfully");
          fetchHolidays(); // Refresh the list
        } else {
          toast.error("Unexpected response from the server.");
        }
      } else {
        toast.error("Error deleting Holiday");
      }
    } catch (error) {
      // Check for specific error status and handle gracefully
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting Holiday.";
        toast.error('Holiday already using cannot delete');
      } else {
        console.error("Error removing Holiday:", error);
        toast.error("Error deleting Holiday. Please try again.");
      }
    }
  };


  const openModal = (holidayId) => {
    setDeleteHollydayId(holidayId);
    setIsModalOpen(true);
  };

  // Close the modal and reset the state
  const closeModal = () => {
    setIsModalOpen(false);
    setDeleteHollydayId(null);
  };

  // Trigger the delete operation and close the modal
  const confirmDelete = () => {
    if (deleteHollydayId) {
      handleDelete(deleteHollydayId); // Ensure handleDelete is defined correctly
    }
    closeModal();
  };

  const currentYear = new Date().getFullYear();

  const [holidayData, setHolidayData] = useState({
    Id: "",
    Name: "",
    Narration: "",
    Remarks: "",
    Year: currentYear.toString(),
    EventDate: "",
    UserId: UID,
  });

  const openAddHolidayModal = () => {
    setHolidayData({
      Id: "",
      Name: "",
      Narration: "",
      Remarks: "",
      Year: currentYear.toString(),
      EventDate: "",
      UserId: UID,
    });
    setAddHolidayModal(!addHolidayModal);
  };

  const openEditHolidayModal = (data) => {
    console.log("data", data);
    // profitcenter id name
    const CategoryName = categorys.find((item) => {
      if (item.Id == data?.CategoryId) {
        console.log(categorys, "crProfit");
        console.log(item, "critem");
        return item?.Name;
      }
    });
    console.log("CategoryName", CategoryName);
    setHolidayData({
      ...data,
      CategoryId: data?.CategoryId,
      // DepartmentId: data.DepartmentId,
      CategoryName: CategoryName?.Name,
      // Department: DepartmentName?.Name,
      UserId: UID || "",
    });
    setEditHolidayModal(!editHolidayModal);
  };

  const fetchHolidays = async () => {
    console.log("jedfskf");

    setLoading(true)
    try {
      const response = await getHoliday(UID);
      console.log(response.data.data, "Fetched data");
      setHolidays(response.data.data); // Store the list of holidays here
      setIsFilterVisible(false)
    } catch (error) {
      console.error("Error fetching holidays", error);
    }
    setLoading(false);
  };


  // Utility function to format the date
  const formatDate = (isoDate) => {
    const date = new Date(isoDate); // Convert ISO string to Date object
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`; // Return in YYYY-MM-DD format
  };

  // year
  const futureYears = 5;
  const years = [];
  for (let year = currentYear; year <= currentYear + futureYears; year++) {
    years.push(year);
  }

  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "Holiday Name",
      selector: (row) => row.Name,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) =>
        new Date(row.EventDate).toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
        }),
      sortable: true,
    },
    

    {
      name: "Year",
      selector: (row) => row.Year,
      sortable: true,
    },

    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditHolidayModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>

        </div>
      ),
    },
  ];


  const filteredItems = useMemo(() => {
    const formatEventDate = (date) => {
      if (!date) return '';
      const eventDate = new Date(date); // Ensure it's a Date object
      return new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).format(eventDate);
    };

    return dataFilter.filter((item) => {
      const matchesSearch =
        !searchText ||
        item.Name?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.Narration?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.Year?.toString().toLowerCase().includes(searchText.toLowerCase()) ||
        formatEventDate(item.EventDate).toLowerCase().includes(searchText.toLowerCase());

      const matchesYear = !selectedYear || item.Year?.toString() === selectedYear;

      return matchesSearch && matchesYear;
    });
  }, [dataFilter, searchText, selectedYear]);

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      setSearchText("");
      setSelectedYear("");
    };

    // return (
    //   <div className="flex gap-5 mb-10 w-full justify-between">
    //     <div className="relative w-full max-w-[221px]">
    //       <select
    //         id="yearFilter"
    //         value={selectedYear}
    //         onChange={(e) => setSelectedYear(e.target.value)}
    //         className="bg-bg-light border border-border w-full py-[6px] px-3 min-h-[40px] rounded-[4px] text-text-primary focus:outline-none"
    //       >
    //         <option value="">Select Year</option>
    //         {Array.from({ length: 50 }, (_, i) => 2024 + i).map((year) => (
    //           <option key={year} value={year.toString()}>
    //             {year}
    //           </option>
    //         ))}
    //       </select>
    //     </div>

    //     <div className="flex flex-row gap-2">
    //       <div className="relative w-full max-w-[221px]">
    //         <input
    //           type="text"
    //           id="search"
    //           value={searchText}
    //           onChange={(e) => setSearchText(e.target.value)}
    //           placeholder="Search here..."
    //           className="bg-bg-light border border-border w-full py-[6px] px-3 min-h-[40px] rounded-[4px] placeholder:text-text-secondary focus:outline-none"
    //         />
    //       </div>
    //       <button onClick={handleClear} className="btn btn-danger">
    //         Clear
    //       </button>
    //     </div>
    //   </div>
    // );
  }, [searchText, selectedYear]);

  useEffect(() => {
    const fetchCategorys = async () => {
      try {
        const response = await getCategorys(UID);
        // const responses = await getDepartments(UID);

        // setDepartment(responses.data.data);
        // console.log(department,"dept");

        setCategorys(response.data.data);
        console.log(categorys, "pro");
      } catch (error) {
        console.error("Error fetching Categorys:", error);
      }
    };

    fetchCategorys();
  }, []);

  useEffect(() => {
    setLoading(true);
    fetchHolidays();
  }, []);

  useEffect(() => {
    if (holidays && holidays.length > 0) {
      const updatedData = holidays.map((item, index) => ({
        Slno: index + 1,
        Id: item.Id || "",
        Name: item.Name || "",
        Narration: item.Narration || "",
        Code: item.Code || "",
        Remarks: item.Remarks || "",
        Year: item.Year || "",
        EventDate: item.EventDate || "",
        CategoryId: item.CategoryId || "",


        UserId: UID,
      }));
      setDataFilter(updatedData); // Correctly map over holidays, not holidayData
    }
    else {
      setDataFilter([]);
    }
  }, [holidays]); // Use holidays as the dependency

  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);  // Update state with the filtered data
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (searchText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setSearchText("");
    }
  };

  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this Holiday?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex items-center justify-between mb-8">
        <Breadcrumb title="Holidays" />

        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search by Holiday/Date/Year"
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={handleClear}
              className="btn btn-danger"
            >
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button
            onClick={openAddHolidayModal}
            className="btn btn-primary"
          >
            Add New
          </button>
        </div>
      </div>


      {isFilterVisible && (
        <FilterComponent columns={columnsFilter} data={holidays} onFilter={handleFilter} />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">

        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>
      {/* 
============================================================Add================================== */}

      {addHolidayModal && (
        <>
          <form onSubmit={handleSubmit}>
            <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Add Holiday
                  <span className="absolute top-0 right-0">
                    <button
                      onClick={openAddHolidayModal}
                      className="btn flex items-center justify-center"
                    >
                      ✖
                    </button>
                  </span>
                </h5>
                <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12 flex-col gap-2 ">
                      <label>
                        Holiday Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        required
                        name="Name"
                        placeholder="Name"
                        value={holidayData.Name}
                        onChange={handleChange}
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                      />
                    </div>
                    {/* <div className="form-group flex col-span-12 flex-col gap-2">
                      <label>
                        Narration
                      </label>
                      <input
                        type="text"
                        id="narration"
                        name="Narration"
                        placeholder="Narration"
                        value={holidayData.Narration}
                        onChange={handleChange}
                      />
                    </div> */}
                   
                    <div className="form-group flex col-span-12 flex-col gap-2">
                      <label htmlFor="year">
                        Select Year: <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        id="year"
                        name="Year"
                        value={holidayData.Year || ""}
                        required
                        onChange={handleChange}
                        className="p-2 border rounded-md"
                      >
                        <option value="" disabled>
                          Select Year
                        </option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>


                    <div className="form-group flex col-span-12 flex-col gap-2">
                      <label>
                        Date <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        id="date"
                        name="EventDate"
                        required
                        placeholder="EventDate"
                        value={holidayData.EventDate}
                        onChange={handleChange}
                        disabled={!holidayData.Year}
                        min={holidayData.Year ? `${holidayData.Year}-01-01` : ""}
                        max={holidayData.Year ? `${holidayData.Year}-12-31` : ""}
                      />

                    </div>

                    <div className="form-group flex col-span-12 flex-col gap-2">
                      <label>Remarks </label>
                      <input
                        type="text"
                        id="remark"
                        name="Remarks"
                        placeholder="Remarks"
                        value={holidayData.Remarks}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Add"}
                  </button>
                </div>
              </div>
            </div>
          </form>
          <div
            // onClick={openAddHolidayModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}

      {/* ============================================================Add================================== */}

      {editHolidayModal && (
        <>

          <form onSubmit={handleEdit}>
            <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Edit Holiday
                  <span className="absolute top-0 right-0">
                    <button
                      type="button"
                      onClick={openEditHolidayModal}
                      className="btn flex items-center justify-center"
                    >
                      ✖
                    </button>
                  </span>
                </h5>
                <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    {/* Name Field */}
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                      Holiday Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="Name"
                        name="Name"
                        placeholder="Name"
                        value={holidayData.Name || ""}
                        onChange={handleChange}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                      />
                    </div>

                    {/* Narration Field */}
                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>Narration</label>
                      <input
                        type="text"
                        id="Narration"
                        name="Narration"
                        placeholder="Narration"
                        value={holidayData.Narration || ""}
                        onChange={handleChange}
                      />
                    </div> */}

                    {/* Remarks Field */}
                   

                    {/* Year Dropdown */}
                    <div className="form-group flex col-span-12 flex-col gap-2">
                      <label htmlFor="year">
                        Select Year: <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        id="year"
                        name="Year"
                        value={holidayData.Year || ""}
                        onChange={handleChange}
                        required
                      >
                        <option value=""disabled >
                          Select a year
                        </option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* <div className="form-group flex col-span-12 flex-col gap-2">
            <label htmlFor="year">
              Select Year: <span style={{ color: "red" }}>*</span>
            </label>
            <select
              id="year"
              name="Year"
              value={holidayData.Year || ""}
              onChange={handleChange}
              required
            >
              <option value="" disabled>
                Select a year
              </option>
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div> */}

                    {/* Event Date */}
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Event Date <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        id="EventDate"
                        name="EventDate"
                        placeholder="Event Date"
                        value={holidayData.EventDate ? formatDate(holidayData.EventDate) : ""}
                        onChange={handleChange}
                        required
                        disabled={!holidayData.Year}
                        min={holidayData.Year ? `${holidayData.Year}-01-01` : ""}
                        max={holidayData.Year ? `${holidayData.Year}-12-31` : ""}
                      />
                    </div>

                    <div className="form-group flex col-span-12 flex-col">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="Remarks"
                        name="Remarks"
                        placeholder="Remarks"
                        value={holidayData.Remarks || ""}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>

                {/* Buttons */}
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearDataForEdit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Edit"}
                  </button>
                </div>
              </div>
            </div>
          </form>

          <div
            // onClick={openEditHolidayModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}

    </>
  );
}
